import * as moment from "moment-timezone"
export const getTimezone = () => {
    return moment.tz.guess()
}